module.exports = __webpack_public_path__ + "img/tooltip_08-vallone-aure-wood-rovere-sand.fe61b92d.jpg";